module.exports = __webpack_public_path__ + "img/latitude-interest-free-logo-white.0c769a2a.svg";